import { useRef, useState } from "react";
import { IoIosArrowDown } from "react-icons/io";
import { toast } from "react-toastify";
import SimpleReactValidator from "simple-react-validator";
import ServiceEnquiry from "../../services/servicesEnquiry";
import { Spinner } from "react-bootstrap";

let goodsPercentage = [
  'None',
  "10%",
  "20%",
  "30%",
  "40%",
  "50%",
  "60%",
  "70%",
  "80%",
  "90%",
  "100%",
];

let moving_type = [
  "1 – 5 Boxes",
  "6 – 15 Boxes",
  "Studio Apt",
  "1 Bed Room Apt",
  "2 Bed Room Apt",
  "3 Bed Room Apt / Villa",
  "4 Bed Room Apt / Villa or More",
];

let relocationType = [
  { name: "Looking for Overseas Moving", value: "Looking for Overseas Moving" },
  { name: "Local Moving", value: "Local Moving" },
  { name: "Office Moving", value: "Office Moving" },
  { name: "Pet Relocation", value: "Pet Relocation" },
  { name: "Vehicle Moving", value: "Vehicle Moving" },
  { name: "Import Relocation", value: "Import Relocation" },
];

let relocationMonths = [
  { id: "JAN", name: "January" },
  { id: "FAB", name: "February" },
  { id: "MAR", name: "March" },
  { id: "APR", name: "April" },
  { id: "MAY", name: "May" },
  { id: "JUNE", name: "June" },
  { id: "JULY", name: "July" },
  { id: "AUG", name: "August" },
  { id: "SEPT", name: "September" },
  { id: "OCT", name: "October" },
  { id: "NOV", name: "November" },
  { id: "DEC", name: "December" },
];

const RelocationEnquiryForm = ({ handleClose }) => {
  const [, setForceUpdate] = useState("");
  const [loader, setLoader] = useState(false);
  const [inputValue, setInputValue] = useState({
    name: "",
    phone: "",
    email: "",
    pickup_address: "",
    delivery_address: "",
    relocation_type: "",
    move_size: "",
    goods_percentage: "",
    relocation_month: "",
    special_request: "",
  });

  const handleChange = (event) => {
    setInputValue({ ...inputValue, [event.target.name]: event.target.value });
  };

  const validator = useRef(
    new SimpleReactValidator({
      autoForceUpdate: { forceUpdate: setForceUpdate },
      messages: {
        required: "Required",
      },
    })
  );

  const handleSubmit = (e) => {
    e.preventDefault();
    let validate = null;

    if (inputValue) {
      validate = validator.current.allValid();
      if (validate) {
        setLoader(true);
        ServiceEnquiry.relocationEnquiry(inputValue)
          .then((res) => {
            setLoader(false);
            if (res.status === true) {
              toast.success(res.message);
              handleClose();
              setInputValue({});
            } else {
              toast.error(res.message);
            }
          })
          .catch((error) => {
            setLoader(false);
            console.log(error);
          });
      } else {
        validator.current.showMessages();
      }
    }
  };

  return (
    <div className="container p-4">
      <div className="row ">
        <form onSubmit={(e) => handleSubmit(e)}>
          <div className="row">
            {/* Name */}
            <div className="mb-3 col-md-6 position-relative">
              <label className="form-label mb-0">
                Customer Name<span className="text-danger">*</span>
              </label>
              <input
                className="form-control p-3"
                type="text"
                onChange={(e) => {
                  handleChange(e);
                }}
                name="name"
                placeholder="Enter Name"
                value={inputValue.name}
              />
              {validator.current.message("Name", inputValue?.name, "required", {
                className: "text-danger",
              })}
            </div>

            {/* Phone */}
            <div className="mb-3 col-md-6 position-relative">
              <label className="form-label mb-0">
                Phone No.<span className="text-danger">*</span>
              </label>
              <input
                onChange={(e) => {
                  handleChange(e);
                }}
                className="form-control p-3"
                type="number"
                min="1"
                name="phone"
                placeholder="Enter Phone No."
                value={inputValue.phone}
              />
              {validator.current.message(
                "Mobile",
                inputValue?.phone,
                "required",
                {
                  className: "text-danger",
                }
              )}
            </div>

            {/* Email */}
            <div className="mb-3 col-md-6 position-relative">
              <label className="form-label mb-0">
                Email<span className="text-danger">*</span>
              </label>
              <input
                className="form-control p-3"
                type="email"
                onChange={(e) => {
                  handleChange(e);
                }}
                min="1"
                name="email"
                placeholder="Enter Email"
                value={inputValue.email}
              />
              {validator.current.message(
                "Email",
                inputValue?.email,
                "required",
                {
                  className: "text-danger",
                }
              )}
            </div>
            {/* Pickup Address */}
            <div className="mb-3 col-md-6 position-relative">
              <label className="form-label mb-0">
                Pickup Address<span className="text-danger">*</span>
              </label>
              <input
                className="form-control p-3"
                type="text"
                onChange={(e) => {
                  handleChange(e);
                }}
                name="pickup_address"
                placeholder="Enter Pickup Address"
                value={inputValue.pickup_address}
              />
              {validator.current.message(
                "Pickup Address",
                inputValue?.pickup_address,
                "required",
                {
                  className: "text-danger",
                }
              )}
            </div>

            {/* Delivery Address */}
            <div className="mb-3 col-md-6 position-relative">
              <label className="form-label mb-0">Delivery Address</label>
              <input
                className="form-control p-3"
                type="text"
                onChange={(e) => {
                  handleChange(e);
                }}
                name="delivery_address"
                placeholder="Enter Delivery Address"
                value={inputValue.delivery_address}
              />
              {validator.current.message(
                "Delivery Address",
                inputValue?.delivery_address,
                "required",
                {
                  className: "text-danger",
                }
              )}
            </div>

            {/* Relocation Types */}
            <div className="mb-3 col-md-6 position-relative">
              <label className="form-label mb-0">
                Relocation Types<span className="text-danger">*</span>
              </label>
              <select
                className="form-control normal_input"
                style={{
                  height: "58px",
                  color: `${inputValue?.relocation_type ? "" : "gray"}`,
                }}
                name="relocation_type"
                onChange={(e) => {
                  handleChange(e);
                }}
                value={inputValue.relocation_type}
              >
                <option selected disabled value="">
                  Select Relocation Type
                </option>

                {relocationType.map((item, index) => {
                  return (
                    <option key={index} value={item?.value}>
                      {item?.name}
                    </option>
                  );
                })}
              </select>
              {validator.current.message(
                "Relocation Type",
                inputValue?.relocation_type,
                "required",
                {
                  className: "text-danger",
                }
              )}
            
            </div>

            {/* Move Size  */}
            <div className="mb-3 col-md-6 position-relative">
              <label className="form-label mb-0">
                Move Size<span className="text-danger">*</span>
              </label>
              <select
                className="form-control normal_input"
                style={{
                  height: "58px",
                  color: `${inputValue?.move_size ? "" : "gray"}`,
                }}
                name="move_size"
                onChange={(e) => {
                  handleChange(e);
                }}
                value={inputValue.move_size}
              >
                <option selected disabled value="">
                  Select Move Size
                </option>
                {moving_type.map((item, i) => (
                  <option className="text-dark" key={i} value={item}>
                    {item}
                  </option>
                ))}
              </select>
              {validator.current.message(
                "Move Size",
                inputValue?.move_size,
                "required",
                {
                  className: "text-danger",
                }
              )}
            
            </div>

            {/* Goods */}
            <div className="mb-3 col-md-6 position-relative">
              <label className="form-label mb-0">
                How much % of Goods is fragile in your Shipment?<span className="text-danger">*</span>
              </label>
              <select
                className="form-control normal_input"
                style={{
                  height: "58px",
                  color: `${inputValue?.goods_percentage ? "" : "gray"}`,
                }}
                name="goods_percentage"
                onChange={(e) => {
                  handleChange(e);
                }}
                value={inputValue.goods_percentage}
              >
                <option selected disabled value="">
                  Goods %
                </option>

                {goodsPercentage.map((item, index) => {
                  return (
                    <option key={index} value={item}>
                      {item}
                    </option>
                  );
                })}
              </select>
              {validator.current.message(
                "Goods %",
                inputValue?.goods_percentage,
                "required",
                {
                  className: "text-danger",
                }
              )}
             
            </div>

            {/* Relocation Month */}
            <div className="mb-3 col-md-6 position-relative">
              <label className="form-label mb-0">
                Relocation Month<span className="text-danger">*</span>
              </label>
              <select
                className="form-control normal_input"
                style={{
                  height: "58px",
                  color: `${inputValue?.relocation_month ? "" : "gray"}`,
                }}
                name="relocation_month"
                onChange={(e) => {
                  handleChange(e);
                }}
                value={inputValue.relocation_month}
              >
                <option selected disabled value="">
                  Select Relocation Month
                </option>

                {relocationMonths.map((item, index) => {
                  return (
                    <option key={index} value={item?.value}>
                      {item?.name}
                    </option>
                  );
                })}
              </select>
              {validator.current.message(
                "Relocation Month",
                inputValue?.relocation_month,
                "required",
                {
                  className: "text-danger",
                }
              )}
             
            </div>

            {/* Special Request */}
            <div className="mb-3 col-md-12 position-relative">
              <label className="form-label mb-0">Special Request</label>
              <input
                className="form-control p-3"
                type="text"
                onChange={(e) => {
                  handleChange(e);
                }}
                name="special_request"
                placeholder="Enter Special Request"
                value={inputValue.special_request}
              />
            </div>
          </div>
          <div className="d-flex justify-content-center">
            <button
              type="button"
              onClick={handleClose}
              disabled={loader}
              className="btn getquoteBtn cancel mb-3 mx-2"
              style={{ padding: " 27px 56px" }}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="btn getquoteBtn mb-3 mx-2"
              disabled={loader}
              style={{ padding: " 27px 56px" }}
            >
              {(loader && <Spinner animation="border" />) || "Submit"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default RelocationEnquiryForm;
